import { useState, useCallback, useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Tooltip,
} from "@material-ui/core";

import { Publish as PublishIcon } from "@material-ui/icons";
import HeaderClientes from "components/_refactor/headers/clients";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import componentStylesCardDeck from "assets/theme/components/cards/card-deck";
import componentStyles from "assets/theme/views/admin/react-bs-table";
import ClearButton from "components/_refactor/button/clear";
import LoadingData from "components/Loading/LoadingData";
import InputText from "components/_refactor/text/input";

import Api from "lib/api/httpRequestHelper";
import MaskAndValid from "utils/maskAndValid";

import DialogUploadRelatorioApuracao from "../../components/Dialogs/DialogUploadRelatorioApuracao";

import { useFormik } from "formik";
import PeriodField, {
  getPeriodLabel,
} from "components/_refactor/fields/period-field";
import {
  columnNumberField,
  columnTextField,
  columnDateField,
  columnDecimalField,
  columnPriceField,
} from "utils/tables-utils";
import { IsMobile900, IsMobile } from "utils/is-mobile";
import AutoCompleteField from "components/_refactor/fields/autocomplete";

const useStyles = makeStyles(componentStyles);
const useStylesCardDeck = makeStyles(componentStylesCardDeck);

const today = new Date();
const dataOntem = new Date(today.setDate(today.getDate() - 1))
  .toISOString()
  .slice(0, 10);
const data30dias = new Date(today.setDate(today.getDate() - 30))
  .toISOString()
  .slice(0, 10);

const columnModel = [
  columnNumberField(
    {
      dataField: "CodCliente",
      text: "Cód. Cliente",
      csvText: "CodCliente",
    },
    true
  ),
  columnTextField(
    {
      dataField: "NomeLojista",
      text: "Nome",
      csvText: "NomeLojista",
    },
    true
  ),
  columnTextField(
    {
      dataField: "Apelido",
      text: "Filial",
      csvText: "Apelido",
    },
    true
  ),
  columnTextField(
    {
      dataField: "CNPJLojista",
      text: "CNPJ",
      formatter: (params) => {
        return MaskAndValid.maskCNPJ(params);
      },
      csvFormatter: (cell) => {
        return MaskAndValid.maskCNPJ(cell);
      },
      csvText: "CNPJLojista",
    },
    true
  ),
  columnNumberField(
    {
      dataField: "IdPedido",
      text: "Nro. Pedido Ecommerce",
      csvText: "IdPedido",
    },
    true
  ),
  columnDateField(
    {
      dataField: "DataEmissaoPedido",
      text: "Data Emissão Pedido",
      csvText: "DataEmissaoPedido",
    },
    true
  ),
  columnTextField(
    {
      dataField: "IdPedidoFvk",
      text: "Nro. Pedido FVK",
      csvText: "IdPedidoFvk",
      csvFormatter: (cell) => {
        return cell ? `'${cell}'` : "";
      },
    },
    true
  ),
  columnNumberField(
    {
      dataField: "IdProduto",
      text: "Cód. Produto",
      csvText: "IdProduto",
    },
    true
  ),
  columnTextField(
    {
      dataField: "TipoProdutoDescricao",
      text: "Tipo de Produto",
    },
    true
  ),
  columnTextField(
    {
      dataField: "Marca",
      text: "Marca",
    },
    true
  ),
  columnNumberField(
    {
      dataField: "EanProduto",
      text: "Cód. Barras Produto",
      csvText: "EanProduto",
      csvFormatter: (cell) => {
        return `'${cell}'`;
      },
    },
    true
  ),
  columnNumberField(
    {
      dataField: "QtdProduto",
      text: "Qtd. Produto",
      csvText: "QtdProduto",
      align: "right",
      footer: (columnData) =>
        "Quantidade total de produtos: " +
        columnData.reduce((acc, item) => acc + item, 0),
    },
    true
  ),
  columnPriceField(
    {
      dataField: "PrecoUnitario",
      csvText: "PrecoUnitario",
      text: "Preço Unitário",
    },
    true
  ),
  columnDecimalField(
    {
      dataField: "PercentualCobrancaComissao",
      csvText: "PercentualCobrancaComissao",
      text: "% Cobrança",
    },
    true
  ),
  columnPriceField(
    {
      dataField: "PrecoUnitarioComTaxa",
      csvText: "PrecoUnitarioComTaxa",
      text: "Preço Unitário Com Taxa",
      csvFormatter: (cell, row) => {
        const priceCalc =
          row.PrecoUnitario * ("1." + row.PercentualCobrancaComissao);

        return row.PrecoUnitario && row.PercentualCobrancaComissao
          ? "R$ " + MaskAndValid.maskPrice(parseFloat(priceCalc).toFixed(2))
          : null;
      },
      formatter: (cell, row) => {
        const priceCalc =
          row.PrecoUnitario * ("1." + row.PercentualCobrancaComissao);

        return row.PrecoUnitario && row.PercentualCobrancaComissao
          ? "R$ " + MaskAndValid.maskPrice(parseFloat(priceCalc).toFixed(2))
          : null;
      },
    },
    true
  ),
  columnPriceField(
    {
      dataField: "PrecoFinal",
      csvText: "PrecoFinal",
      text: "Preço Final",
    },
    true
  ),
  columnTextField(
    {
      dataField: "NomeProduto",
      text: "Produto",
      csvText: "NomeProduto",
    },
    true
  ),
  {
    dataField: "IdMarca",
    text: "IdMarca",
    hidden: true,
  },
  {
    dataField: "Id",
    text: "Id",
    hidden: true,
  },
  {
    dataField: "DtHoraImportacao",
    text: "DtHoraImportacao",
    hidden: true,
    csvFormatter: (cell) => {
      return cell || "";
    },
  },
  {
    dataField: "IdUsuarioImportacao",
    text: "IdUsuarioImportacao",
    hidden: true,
    csvFormatter: (cell) => {
      return cell || "";
    },
  },
];

function validatePeriod(period, periodInicial, periodFinal) {
  return period === "Outros"
    ? MaskAndValid.validateDate(periodInicial) &&
        MaskAndValid.validateDate(periodFinal) &&
        periodInicial <= periodFinal
    : true;
}

const validate = (values) => {
  const errors = {};

  if (values.cnpj.length > 0 && values.cnpj.length < 17) {
    errors.cnpj = "CNPJ inválido";
  }

  if (!values.situation.length) {
    errors.situation = "Situação Pedido obrigatório";
  }

  return errors;
};

const statusOption = [
  {
    value: "G",
    name: "Pedido FVK Gerado",
  },
  {
    value: "P",
    name: "Pedido FVK Pendente",
  },
];

function RelatorioApuracaoPrateleiraInfinita() {
  const classes = { ...useStyles(), ...useStylesCardDeck() };

  const [resultados, setResultados] = useState(null);
  const [searching, setSearching] = useState(false);
  const [periodoPedidos, setPeriodoPedidos] = useState(null);
  const [dataInicialPedidos, setDataInicialPedidos] = useState(data30dias);
  const [dataFinalPedidos, setDataFinalPedidos] = useState(dataOntem);
  const snackbar = useSnackbar();
  const [labelHeader, setLabelHeader] = useState("");
  const [cancelLoading, setCancelLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [openImportarRelatorio, setOpenImportarRelatorio] = useState(false);

  const isMobile900 = IsMobile900();
  const isMobile = IsMobile();

  const itemXS = isMobile ? 12 : isMobile900 ? 6 : 3;

  const toggleOpenImportar = useCallback(() => {
    setOpenImportarRelatorio(!openImportarRelatorio);
  }, [openImportarRelatorio]);

  const pesquisar = useCallback(
    async (values) => {

      const { cnpj, situation } = values;
      setCancelLoading(false);
      setResultados(null);
      setSearching(true);
      setErrorMessage("");

      Api.get(
        "report-infinite-shelf",
        "sellinorder",
        "?situacao=" +
          situation +
          "&cnpj=" +
          cnpj +
          `&dtIni=${dataInicialPedidos}&dtFim=${dataFinalPedidos}`,
        true
      )
        .then((value) => {
          if (value.Result.length > 0) {
            setLabelHeader(
              `Apuração ${getPeriodLabel({
                period: periodoPedidos?.value,
                initialDate: dataInicialPedidos,
                finalDate: dataFinalPedidos,
              })}`
            );
          }
          setResultados(value.Result);
        })
        .catch((error) => {
          setErrorMessage(error);        })
        .finally(() => setSearching(false));
    },
    [dataFinalPedidos, dataInicialPedidos, periodoPedidos]
  );

  const formik = useFormik({
    initialValues: {
      cnpj: "",
      situation: "P",
    },
    onSubmit: pesquisar,
    validate,
  });

  const { values, errors, handleChange, handleSubmit } = formik;

  const handleClearFilters = () => {
    setSearching(true);
    setPeriodoPedidos(null);
    setDataInicialPedidos(data30dias);
    setDataFinalPedidos(dataOntem);

    handleChange({
      target: {
        name: "cnpj",
        value: "",
      },
    });
    handleChange({
      target: {
        name: "situation",
        value: "P",
      },
    });

    setSearching(false);
  };

  const handleStopSearching = () => {
    setCancelLoading(true);
    setSearching(false);
    setResultados(null);
  };

  useEffect(() => {
    if (errorMessage !== "" && !cancelLoading) {
      snackbar.showMessage(errorMessage, {
        severity: "error",
      });
    }
  }, [cancelLoading, errorMessage]);

  return (
    <>
      <HeaderClientes
        section="Relatório de Apuração Prateleira Infinita"
        subsection="Pedidos"
      />
      <Container style={{ marginTop: "-4.5rem" }} maxWidth={false}>
        <Grid container>
          <Grid item xs={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title="Filtros"
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
                action={
                  <Tooltip
                    title={isMobile ? "Importar Relatórios" : ""}
                    placement="bottom"
                  >
                    <Button
                      color="default"
                      variant="outlined"
                      disabled={searching}
                      onClick={toggleOpenImportar}
                      startIcon={
                        !isMobile && (
                          <PublishIcon style={{ width: 18, height: 18 }} />
                        )
                      }
                    >
                      {isMobile ? (
                        <PublishIcon style={{ width: 20, height: 20 }} />
                      ) : (
                        "Importar Relatório"
                      )}
                    </Button>
                  </Tooltip>
                }
              ></CardHeader>
              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={itemXS}>
                    <InputText
                      label="CNPJ Lojista"
                      value={values.cnpj}
                      onChange={(e) => {
                        const maskedValue = MaskAndValid.maskCNPJ(
                          e.target.value.slice(0, 18)
                        );
                        handleChange({
                          target: {
                            name: "cnpj",
                            value: maskedValue,
                          },
                        });
                      }}
                      disabled={searching}
                      placeholder="00.000.000/0000-00"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={periodoPedidos?.value === "Outros" ? "12" : "3"}
                  >
                    <PeriodField
                      label="Período do Pedido"
                      value={periodoPedidos}
                      onChange={setPeriodoPedidos}
                      initialDate={dataInicialPedidos}
                      finalDate={dataFinalPedidos}
                      setInitialDate={setDataInicialPedidos}
                      setFinalDate={setDataFinalPedidos}
                      disabled={searching}
                      required={false}
                    />
                  </Grid>
                  <Grid item xs={itemXS}>
                    <AutoCompleteField
                      label="Situação Pedido"
                      options={statusOption}
                      optionLabelKey="name"
                      optionIdKey="value"
                      value={
                        statusOption?.find(
                          (item) => item.value === values.situation
                        ) || null
                      }
                      disabled={searching}
                      onChange={(newValue) => {
                        handleChange({
                          target: {
                            name: "situation",
                            value: newValue ? newValue.value : "",
                          },
                        });
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Button
                      style={
                        isMobile || isMobile900
                          ? {
                              width: "100%",
                              marginBottom: "0.75rem",
                              marginTop: "0.75rem",
                            }
                          : { marginBottom: "0rem" }
                      }
                      color="default"
                      variant="contained"
                      onClick={handleSubmit}
                      disabled={
                        searching ||
                        Object.entries(errors).length > 0 ||
                        !validatePeriod(
                          periodoPedidos?.value,
                          dataInicialPedidos,
                          dataFinalPedidos
                        )
                      }
                    >
                      {searching ? "Pesquisando..." : "Pesquisar"}
                    </Button>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <ClearButton
                      fullWidth={true}
                      disable={searching}
                      onClick={() => handleClearFilters()}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <LoadingData
              searching={searching}
              onClick={() => handleStopSearching()}
              classes={classes.root}
              label="Buscando dados..."
            />
          </Grid>
          {resultados && !cancelLoading ? (
            <Grid item xs={12}>
              <ToolkitTable
                keyField="idProduto"
                dataTable={resultados}
                searched={Boolean(resultados)}
                columnModel={columnModel}
                headerTitle={labelHeader}
                csvFileName="RelatorioApuracaoPrateleiraInfinita.csv"
                pagination={{
                  options: [25, 50, 100],
                  defaultOption: 25,
                }}
                hasFooter
              />
            </Grid>
          ) : null}
        </Grid>
      </Container>
      <DialogUploadRelatorioApuracao
        open={openImportarRelatorio}
        onClose={toggleOpenImportar}
      />
    </>
  );
}

export default RelatorioApuracaoPrateleiraInfinita;
